// Simple state-based router. No URL/hash for now — page state lives in memory.
// Pages are pre-rendered DOM sections; switching toggles a `.active` class.
// Subscribers (e.g. main's render loop) listen for PageChange.

import { Events, emit } from './eventBus.js'

const PAGES = ['home', 'play', 'shop', 'vland', 'guide', 'registry', 'overview']

let currentPage = 'home'
const sections = new Map()

export function init({ rootSelector = '.site-page' } = {}) {
  document.querySelectorAll(rootSelector).forEach((el) => {
    const id = el.dataset.pageView
    if (id) sections.set(id, el)
  })
  // Apply initial visibility.
  apply()
}

export function getActivePage() {
  return currentPage
}

export function setActivePage(id) {
  if (!PAGES.includes(id)) return false
  if (id === currentPage) return false
  currentPage = id
  apply()
  emit(Events.PageChange, { page: id })
  return true
}

export function listPages() {
  return PAGES.slice()
}

function apply() {
  for (const [id, el] of sections) {
    el.classList.toggle('active', id === currentPage)
  }
  // Stamp the active page on <body> so CSS can scope body-level game UI (the
  // fixed minimap + rotate arrows live on <body>, not inside #hud) to the play
  // page — otherwise they'd leak onto the marketing pages.
  document.body.dataset.activePage = currentPage
}
